import React from 'react';
import type { IconProps } from '../types';

const Icon3d = (props: IconProps) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.918 1.49463C11.0042 1.45545 11.1032 1.45545 11.1895 1.49463L20.7568 5.84131C20.874 5.89456 20.9492 6.01147 20.9492 6.14014V17.1255C20.9491 17.2426 20.8866 17.3511 20.7852 17.4097L11.2178 22.9331C11.1163 22.9917 10.9912 22.9917 10.8896 22.9331L1.32227 17.4097C1.22083 17.3511 1.15831 17.2426 1.1582 17.1255V6.14014C1.1582 6.01147 1.23346 5.89456 1.35059 5.84131L10.918 1.49463Z"
      stroke="white"
      strokeWidth="1.20904"
      strokeLinecap="round"
    />
    <path
      d="M11.1868 22.3934V10.9488L1.86035 6.13879"
      stroke="white"
      strokeWidth="1.20904"
      strokeLinecap="round"
    />
    <path
      d="M11.1875 11.1129L20.1586 6.13879"
      stroke="white"
      strokeWidth="1.20904"
      strokeLinecap="round"
    />
    <path
      d="M16.3545 10.846C16.9671 10.5203 17.4976 10.3745 17.9461 10.4086C18.4001 10.4335 18.7529 10.6238 19.0045 10.9794C19.2561 11.335 19.3819 11.8442 19.3819 12.5071C19.3819 13.1637 19.2561 13.8005 19.0045 14.4174C18.7529 15.0344 18.4001 15.5967 17.9461 16.1045C17.4976 16.6093 16.9671 17.0246 16.3545 17.3503L14.2132 18.4889V11.9846L16.3545 10.846ZM16.3217 16.3178C16.9397 15.9892 17.4156 15.5441 17.7492 14.9827C18.0828 14.415 18.2497 13.7905 18.2497 13.1091C18.2497 12.4215 18.0828 11.9681 17.7492 11.7491C17.4156 11.53 16.9397 11.5848 16.3217 11.9134L15.3207 12.4456V16.85L16.3217 16.3178Z"
      fill="white"
    />
    <path
      d="M3.86037 11.3636C3.85903 10.9512 3.93549 10.655 4.08973 10.4749C4.24906 10.2918 4.46758 10.2163 4.74528 10.2485C5.02808 10.2776 5.35681 10.4092 5.73148 10.6432C6.1222 10.8872 6.45755 11.1795 6.73753 11.5202C7.01751 11.8609 7.2356 12.2183 7.3918 12.5922C7.548 12.9662 7.6331 13.3234 7.64712 13.6639C7.65777 13.9224 7.62162 14.121 7.53868 14.2596C7.46083 14.3953 7.35492 14.4827 7.22095 14.5219C7.08672 14.5548 6.95132 14.5593 6.81476 14.5355L6.81632 14.5733C7.01721 14.7663 7.19532 14.9758 7.35064 15.2018C7.50595 15.4278 7.62791 15.6668 7.7165 15.9187C7.81045 16.1739 7.86339 16.4465 7.87534 16.7366C7.89065 17.1085 7.82922 17.3896 7.69104 17.5797C7.5526 17.7636 7.34478 17.8457 7.0676 17.8262C6.79576 17.81 6.45646 17.6749 6.04968 17.4209C5.64825 17.1702 5.29214 16.8802 4.98134 16.551C4.67054 16.2218 4.4206 15.8507 4.23151 15.4377C4.04216 15.0185 3.92907 14.5517 3.89225 14.0372L4.95201 14.699C4.97674 15.0462 5.07009 15.3502 5.23205 15.6111C5.39402 15.8719 5.64361 16.1077 5.98081 16.3182C6.17349 16.4386 6.32996 16.5025 6.45021 16.51C6.57046 16.5175 6.65729 16.4735 6.71072 16.3778C6.76414 16.2822 6.78696 16.1398 6.77917 15.9507C6.76411 15.585 6.65242 15.2787 6.4441 15.0319C6.24113 14.7884 5.92555 14.533 5.49736 14.2656L5.27256 14.1252L5.2305 13.1038L5.46333 13.2492C5.68787 13.3833 5.88487 13.4817 6.05432 13.5446C6.22352 13.6011 6.35128 13.601 6.4376 13.5444C6.52901 13.4847 6.57043 13.3509 6.56186 13.1428C6.5507 12.8717 6.47725 12.6078 6.34153 12.351C6.20554 12.0879 6.00641 11.8745 5.74415 11.7107C5.55146 11.5904 5.39793 11.5345 5.28355 11.5429C5.16918 11.5513 5.07979 11.5969 5.01541 11.6795C4.95637 11.7655 4.92462 11.8808 4.92014 12.0254L3.86037 11.3636Z"
      fill="white"
    />
  </svg>
);

export default Icon3d;
